(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reflectionare-product-like"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reflectionare-product-like')) {
    customElements.define('reflectionare-product-like', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('button');
        this.count = this.querySelector('.reflectionare-like-count');
        this.label = this.querySelector('.reflectionare-like-label');
        this.error = this.querySelector('.reflectionare-like-error');
        this.liked = false;
        this.ready = false;
        this.busy = false;
        this.refreshing = false;
        this.version = 0;
        this.abort = new AbortController();
        this.onRefresh = () => { if (!document.hidden && !this.busy) this.refresh(); };
        try {
          const key = 'reflectionare_like_visitor_v1';
          let visitor = localStorage.getItem(key);
          if (!/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(visitor || '')) {
            visitor = crypto.randomUUID();
            localStorage.setItem(key, visitor);
          }
          this.endpoint = new URL(this.dataset.endpoint);
          this.endpoint.searchParams.set('product', this.dataset.product);
          this.endpoint.searchParams.set('visitor', visitor);
          this.cacheKey = 'reflectionare_like_state_' + this.dataset.product;
          try {
            const cached = JSON.parse(sessionStorage.getItem(this.cacheKey) || 'null');
            if (cached && Number.isSafeInteger(cached.count) && cached.count >= 0 && typeof cached.liked === 'boolean') {
              this.show(cached);
            }
          } catch {}
        } catch {
          this.count.hidden = true;
          this.error.textContent = this.dataset.storage;
          this.button.disabled = true;
          return;
        }
        this.button.addEventListener('click', () => this.save(), { signal: this.abort.signal });
        document.addEventListener('visibilitychange', this.onRefresh, { signal: this.abort.signal });
        window.addEventListener('focus', this.onRefresh, { signal: this.abort.signal });
        window.addEventListener('reflectionare:likes-updated', this.onRefresh, { signal: this.abort.signal });
        this.timer = setInterval(this.onRefresh, 30000);
        this.refresh();
      }
      disconnectedCallback() {
        this.abort?.abort();
        clearInterval(this.timer);
        clearTimeout(this.animationTimer);
        this.initialized = false;
      }
      async request(method, liked) {
        const options = {
          method,
          credentials: 'omit',
          cache: 'no-store',
          signal: AbortSignal.any([this.abort.signal, AbortSignal.timeout(method === 'GET' ? 6000 : 12000)])
        };
        if (method === 'PUT') {
          options.headers = { 'Content-Type': 'application/json' };
          options.body = JSON.stringify({ liked, handle: this.dataset.handle });
        }
        const response = await fetch(this.endpoint, options);
        if (!response.ok) throw new Error('Likes unavailable');
        const state = await response.json();
        if (!Number.isSafeInteger(state.count) || state.count < 0 || typeof state.liked !== 'boolean') {
          throw new Error('Invalid count');
        }
        return state;
      }
      renderLiked(liked) {
        this.liked = liked;
        this.label.textContent = liked ? this.dataset.liked : this.dataset.idle;
        this.button.setAttribute('aria-pressed', String(liked));
      }
      show(state) {
        this.renderLiked(state.liked);
        this.ready = true;
        this.count.textContent = String(state.count);
        this.count.hidden = false;
        this.error.textContent = '';
        try { sessionStorage.setItem(this.cacheKey, JSON.stringify(state)); } catch {}
      }
      celebrate() {
        this.button.classList.remove('is-celebrating');
        void this.button.offsetWidth;
        this.button.classList.add('is-celebrating');
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(() => this.button.classList.remove('is-celebrating'), 650);
      }
      async refresh() {
        if (this.refreshing || this.busy || !this.endpoint) return;
        this.refreshing = true;
        const version = this.version;
        try {
          const state = await this.request('GET');
          if (version === this.version && !this.busy) this.show(state);
        } catch {
          if (!this.abort.signal.aborted && !this.ready && version === this.version && !this.busy) {
            this.count.hidden = true;
            this.error.textContent = this.dataset.error;
          }
        } finally {
          this.refreshing = false;
        }
      }
      async save() {
        if (this.busy || !this.endpoint) return;
        this.busy = true;
        this.version += 1;
        const previous = {
          liked: this.liked,
          count: this.count.textContent,
          countHidden: this.count.hidden,
          ready: this.ready
        };
        const next = !this.liked;
        this.renderLiked(next);
        if (next) this.celebrate();
        if (!this.count.hidden) {
          const count = Number(this.count.textContent);
          if (Number.isSafeInteger(count)) this.count.textContent = String(Math.max(0, count + (next ? 1 : -1)));
        }
        this.error.textContent = '';
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        try {
          this.show(await this.request('PUT', next));
          window.dispatchEvent(new Event('reflectionare:likes-updated'));
        } catch {
          if (!this.abort.signal.aborted) {
            this.renderLiked(previous.liked);
            this.count.textContent = previous.count;
            this.count.hidden = previous.countHidden;
            this.ready = previous.ready;
            this.button.classList.remove('is-celebrating');
            this.error.textContent = this.dataset.error;
          }
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
